const DEFERRED_FINANCIAL_PERIOD_WARNING = /^Financial period (?:start|end) was not confirmed by staff\.?$/i

export function filterBizfileSourceWarnings(warnings = []) {
    const uniqueWarnings = new Set()

    for (const warning of Array.isArray(warnings) ? warnings : []) {
        const text = String(warning || '').replace(/\s+/g, ' ').trim()
        if (!text || DEFERRED_FINANCIAL_PERIOD_WARNING.test(text)) continue
        uniqueWarnings.add(text)
    }

    return [...uniqueWarnings]
}
